import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PublicNotFound from "../scenes/notFoundPages/PublicNotFound";

export default function PublicRouteGuard({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if user has any token (doctor or tenant)
  const hasDoctorToken = localStorage.getItem("token");
  const hasTenantToken = localStorage.getItem("tokenTenant");
  const hasSuperAdminToken = localStorage.getItem("superAdminToken");
  
  // If no token at all, show PublicNotFound
  if (!hasDoctorToken && !hasTenantToken && !hasSuperAdminToken) {
    return <PublicNotFound />;
  }
  
  // If has token, show the protected content
  return children;
}

